import { TileViewService } from './tile-view.service';
import { SelectedPlantService } from './selected-plant.service';
import { AssetToastService } from './asset-toast.service';
import { GeneralEventsService } from './general-events.service';
import { ServiceHelpDeskService } from './service-help-desk.service';

export const serviceProviders = [
  TileViewService,
  SelectedPlantService,
  AssetToastService,
  GeneralEventsService,
  ServiceHelpDeskService,
];

export * from './tile-view.service';
export * from './selected-plant.service';
export * from './asset-toast.service';
export * from './general-events.service';
export * from './service-help-desk.service';
